enum ChangeApprovalStatus {
  PendingApprove = 0,
  Approved = 1,
  Rejected = 2,
  PendingReview = 3,
}

export default ChangeApprovalStatus;
